import { Collection } from "../../../../utils/types";
import { groupBy } from "../../../../utils";

export function CollectionSelector({
  collections,
  removeCollection,
}: {
  collections: Collection[];
  removeCollection: (collection_id: string) => void;
}) {
  const grouped = groupBy(collections, "salesforce_id");

  const keys = Object.keys(grouped);

  return (
    <div>
      {keys.map(function (x, i) {
        return (
          <div key={i} className="border-b w-full p-4">
            <div className="w-full flex flex-wrap">
              {grouped[x].map(function (collection: Collection, key: number) {
                return (
                  <div className="border m-2 p-2 rounded" key={key}>
                    <button
                      className="w-full flex flex-row justify-between"
                      onClick={() => removeCollection(collection.id)}
                    >
                      <div className="flex flex-col text-left mr-4">
                        <p className="text-xs">title: {collection.title}</p>
                        <p className="text-xs">store: {collection.store}</p>
                        <p className="text-xs">handle: {collection.handle}</p>
                        <p className="text-xs">
                          salesforce id: {collection.salesforce_id}
                        </p>
                      </div>
                      <p className="underline">X</p>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
